<template>
    <button class="btn btn-primary btn-sm connect-with" :title="__('connect_with')" :disabled="disabled" @click="showModal">
        <i class="far fa-clone"></i>&nbsp;{{ __('connect_with') }}&nbsp;
    </button>
</template>

<script>
    import events from './../services/Events.js';
    import actions from './../vuex/action_types.js'
    import mutations from './../vuex/mutation_types.js'
    import axios from "axios";
    import hasConnectWith from "../mixins/hasConnectWith";

    export default {
        name: "button-show-modal-connect-with",
        mixins: [hasConnectWith],
        data: function() {
            return {
                disabled: true,
                preValidateTimeout: null,
                cancelToken: null
            }
        },
        methods: {
            showModal: function() {
                let input_data = {
                    operations: this.$store.getters.getSelectedOperations,
                    documents: this.$store.getters.getSelectedDocuments,
                    url: $('#current-url-to-lock').val(),
                    route:$('#current-route-to-lock').val()
                };

                if(input_data.operations.length >= 1 && input_data.documents.length >= 1 || input_data.operations.length >= 1 || input_data.documents.length >= 1) {
                    this.checkIfConnected(input_data);
                } else {
                    events.$emit('showConnectWithModal', []);
                }
            },
            checkIfConnected: function(input_data) {
                this.$store.dispatch(actions.CHECK_IF_CONNECTED, input_data)
                    .then((response) => {
                        if (response.data.connected == 'true') {
                            this.deleteConnected(input_data)
                        } else {
                            this.$store.dispatch(actions.CHECK_CAN_CONNECT, input_data)
                                .then((response) => {
                                    if (response.data.can_connect == 'true') {
                                        events.$emit('showConnectWithModal', []);
                                    }
                                    else{
                                        window.location = response.data.redirect_url;
                                    }
                                })
                        }
                    })
            },
            deleteConnected: function(input_data) {
                let self = this;
                this.$swal({
                    title: self.__("delete_allocation"),
                    text: self.__("chosen_document_and_payments_are_already_related") + ' '
                        + self.__('clear_allocation_so_that_the_relation_can_be_created_anew'),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: self.__("delete"),
                    cancelButtonText: self.__("cancel"),
                    closeOnConfirm: true,
                    reverseButtons: true
                }).then(result => {
                    if(result.value === true) {
                        this.$store.dispatch(actions.DELETE_CONNECTED, input_data)
                            .then(function(response){
                                if(response.data.deleted >= 1) {
                                    self.preValidateSelected();
                                    self.$emit('view:refresh', {})
                                }
                            })
                    }
                });
            },
            preValidateSelected: function() {
                const documents = this.$store.getters.getSelectedDocuments;
                const operations = this.$store.getters.getSelectedOperations;
                const serverInfo = this.$store.getters.getServerInfo;
                let typeOfInterpretation = this.getInterpretationType(documents, operations)

                if(typeOfInterpretation != ''){
                    if(this.cancelToken == null){
                        this.cancelToken = axios.CancelToken.source();
                    }
                    else{
                        this.cancelToken.cancel()
                        this.cancelToken = axios.CancelToken.source();
                    }
                    if (this.preValidateTimeout) clearTimeout(this.preValidateTimeout);
                    this.preValidateTimeout = setTimeout(() => {
                        this.$store.dispatch(actions.PRE_VALIDATE_SELECTED, {
                                selected: {
                                    documents, operations, typeOfInterpretation
                                },
                                options: {
                                    cancelToken: this.cancelToken.token
                                }
                            }
                        )
                            .then(response => {
                                if( response !== undefined && response.data.status.toLowerCase() === 'ok') {
                                    this.disabled = false;
                                    this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATA, response.data.result);
                                    this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_OPTIONS, response.data.options);
                                    this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATE, serverInfo.date);
                                    this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DESCRIPTION, '');
                                    this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_CURRENCY_EXCHANGE, false);

                                } else {
                                    this.disabled = true;
                                }
                            })

                    }, 200);
                }
                else{
                    this.disabled = true
                }

            },
        },
        created: function() {
            this.$store.subscribe((mutation, state) => {
                const types = [
                    mutations.SELECT_OPERATION,
                    mutations.REMOVE_OPERATION,
                    mutations.SELECT_DOCUMENT,
                    mutations.REMOVE_DOCUMENT
                ];
                if (types.includes(mutation.type)) {
                    this.disabled = true;
                    this.preValidateSelected();
                }
            });
        },
    }
</script>

<style scoped>

</style>
